import { useContext, useEffect, useState } from "react"
import { AppContext } from "../App"
import { PiBuildingOfficeBold, PiStudent } from "react-icons/pi";
import { formatMoney, formatMoneyShorten } from "../Helpers";
import { FaChalkboardTeacher } from "react-icons/fa";
import { SiGoogleclassroom } from "react-icons/si";
import { IoIosPeople } from "react-icons/io";
import { getInlineLoader } from "../Helpers";
import banner1 from '../assets/banner1.jpg';
import banner2 from '../assets/banner2.jpeg';
import banner3 from '../assets/banner3.jpg';
import banner4 from '../assets/banner4.jpg';
import banner5 from '../assets/banner5.jpg';
import logo_icon from '../assets/logo_icon.png';
import { MdLocationPin, MdSearch } from "react-icons/md";
import OneHotelFeed from "./OneHotelFeed";

export default function HotelsBanner1(props) {

	const appContext = useContext(AppContext);

	/* Place states here */
	const [ ready, setReady ] = useState(false);
	const [ searchResults, setSearchResults] = useState(null);

	async function init() {
		//run initializations here
		setReady(false);
		//..
		await Promise.all([
			appContext.getAvailableHotels(),
		])
		setReady(true);
	}


	useEffect(() => {
		if(appContext.globalSearchFilter && appContext.availableHotels) {
			const _results = appContext.availableHotels.filter((item, i) => {
				if(
					String(item.name).toLowerCase().indexOf(String(appContext.globalSearchFilter).toLowerCase()) > -1 ||
					String(item.description).toLowerCase().indexOf(String(appContext.globalSearchFilter).toLowerCase()) > -1
				) {
					return true;
				} else {
					return false;
				}
			});

			setSearchResults(_results);
		}
	}, [ appContext.globalSearchFilter ])

	useEffect(() => {
		init();
	}, [ ])

	if(ready) {
		return (
			<div 
				className="MainBodySection"
				style={{
					paddingBottom: "50px",
					paddingTop: "50px"
				}}
			>
				<div className="container">
					<div className="row">
						<div className="col-md-12">
							<h6
								className="main-section-title"
							>
								Available Hotels
							</h6>
						</div>

						<div 
							className="col-md-12 mb-4 mt-4"
						>
							<div
								style={{
									width: "100%",
									height: "auto",
									padding: "10px",
									borderRadius: "10px"
								}}

								className="bg-surface mShadow3"
							>
								<div className="row">
									<div className="col-md-6 col-12">
									
										<label className="form-label">Where To?</label>
										<div className="input-group mb-3">
											<span 
												className="input-group-text" id="basic-addon1"
											>
												<MdLocationPin size={32}/>
											</span>
											<input 
												type="text" 
												className="form-control" 
												placeholder="Hotel Name, Region or district" 
												aria-label="Hotel Name, Region or district" 
												aria-describedby="basic-addon1" 
												value={appContext.globalSearchFilter || ''}
												onChange={(e) => appContext.setGlobalSearchFilter(e.target.value)}
											/>
										</div>
										
									</div>

									
								</div>
							</div>
						</div>

						{
							(appContext.globalSearchFilter && appContext.globalSearchFilter.trim().length > 0) ?
							<div 
								className="col-md-12 mt-5 mb-5"
							>
								<hr/>

								<h6
									style={{
										fontSize: "32px",

									}}
									className="font-light"
								>
									Results for:
									<br/>
									<span style={{ fontSize: "16px" }} className="font-bold text-primary">{appContext.globalSearchFilter}</span>
								</h6>

								<div className="row">
									{
										(searchResults && searchResults.length > 0) ?
										<>
											{
												searchResults.map((item, i) => {
													return (
														<div
															className={(i <= 1) ? "col-md-6" : "col-md-4"}
															key={i}
														>
															<OneHotelFeed data={item} />
														</div>
													)
												})
											}

										</>
										:
										<div className="col-md-12">
											<h6>No hotels were found for your search</h6>
										</div>
									}
								</div>
								
								<hr/>
							</div>
							:
							(appContext.availableHotels && appContext.availableHotels.length > 0) ?
							<>
								{
									appContext.availableHotels.map((item, i) => {
										return (
											<div
												className={(i <= 1) ? "col-md-6" : "col-md-4"}
												key={i}
											>
												<OneHotelFeed data={item} />
											</div>
										)
									})
								}

							</>
							:
							<div className="col-md-12">
								<h6>No hotels were found</h6>
							</div>
						}

					</div>
				</div>
			</div>
		)
	} else {
		return (
			<div 
				className="container mSupportLoading"
			>
				{getInlineLoader()}
			</div>
		);
	}

	
}